export default __webpack_public_path__ + "static/media/O-038.b9d36a64.png";